import React from 'react';
import Image from 'next/image';

import {sprinkles} from '#style/sprinkles';

import {ImpactImageProps} from './ImpactImage.types';

import * as css from './ImpactImage.css';

function ImpactImage({imageUrl, impactLevel, increaseSize = false}: ImpactImageProps) {
  return (
    <div
      className={sprinkles({
        display: 'flex',
        dir: 'rowReverse',
        content: 'start',
      })}>
      <div
        className={css.imageBg({
          impactLevel: impactLevel ?? 'Other',
          body: increaseSize ? 'large' : 'medium',
        })}
      />

      <div className={increaseSize ? css.imageIncreased : css.image}>
        <Image
          alt=""
          aria-hidden
          className={sprinkles({pos: 'absolute', inset: 0})}
          layout="fill"
          src={imageUrl || ''}
        />
      </div>
    </div>
  );
}

export {ImpactImage};
